export const DownloadIcon = ({
  disabled,
  useCurrentColor = false,
}: {
  disabled?: boolean;
  useCurrentColor?: boolean;
}) => {
  const fillColor = useCurrentColor ? 'currentColor' : disabled ? '#727272' : '#C1C1C2';

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 1C11 0.447715 10.5523 0 10 0C9.44771 0 9 0.447715 9 1V12.5858L4.70711 8.29289C4.31658 7.90237 3.68342 7.90237 3.29289 8.29289C2.90237 8.68342 2.90237 9.31658 3.29289 9.70711L9.29289 15.7071C9.68342 16.0976 10.3166 16.0976 10.7071 15.7071L16.7071 9.70711C17.0976 9.31658 17.0976 8.68342 16.7071 8.29289C16.3166 7.90237 15.6834 7.90237 15.2929 8.29289L11 12.5858V1Z"
        fill={fillColor}
      />
      <path
        d="M0 19C0 18.4477 0.447715 18 1 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20H1C0.447715 20 0 19.5523 0 19Z"
        fill={fillColor}
      />
    </svg>
  );
};
